function getCardGallery(el) {
  // I pallini colore non stanno piu' dentro la figura ma sotto la foto, quindi
  // closest('.card-custom-image') non li ritroverebbe: si risale alla card e da
  // li' si scende alla figura.
  var figure = el.closest('.card-custom-image');
  if (!figure) {
    var card = el.closest('.card-wrapper') || el.closest('.card-custom') || el.closest('.card');
    figure = card ? card.querySelector('.card-custom-image') : null;
  }
  if (!figure) return null;
  return {
    figure: figure,
    gallery: figure.querySelector('[data-card-gallery]'),
    dotsWrap: figure.querySelector('[data-card-gallery-dots]'),
  };
}

function setActiveDot(dotsWrap, index) {
  if (!dotsWrap) return;
  var dots = dotsWrap.querySelectorAll('.card-gallery__dot');
  dots.forEach(function (dot, i) {
    dot.classList.toggle('is-active', i === index);
  });
}

function loadSlideImage(slide) {
  if (!slide) return;
  var img = slide.querySelector('img[data-src]');
  if (!img) return;
  if (img.dataset.srcset) {
    img.srcset = img.dataset.srcset;
    img.removeAttribute('data-srcset');
  }
  img.src = img.dataset.src;
  img.removeAttribute('data-src');
}

// Le card hanno larghezze frazionarie, quindi clientWidth (arrotondato) accumula
// errore slide dopo slide: la posizione si calcola dalla slide stessa.
// La foto successiva si scarica mentre il dito e' ancora sullo schermo, non
// quando e' gia' in vista: altrimenti si vede comparire in ritardo.
function preloadNeighbours(gallery, index) {
  var slides = gallery.querySelectorAll('.card-gallery__slide');
  loadSlideImage(slides[index + 1]);
  if (index > 0) loadSlideImage(slides[index - 1]);
}

function scrollGalleryToIndex(gallery, index, behavior) {
  if (!gallery) return;
  var slide = gallery.querySelectorAll('.card-gallery__slide')[index];
  if (!slide) return;
  loadSlideImage(slide);
  preloadNeighbours(gallery, index);
  var left = gallery.scrollLeft + (slide.getBoundingClientRect().left - gallery.getBoundingClientRect().left);
  gallery.scrollTo({ left: left, behavior: behavior || 'smooth' });
}

function getActiveSlideIndex(gallery) {
  var slides = gallery.querySelectorAll('.card-gallery__slide');
  var galleryLeft = gallery.getBoundingClientRect().left;
  var best = 0;
  var bestDistance = Infinity;
  for (var i = 0; i < slides.length; i++) {
    var distance = Math.abs(slides[i].getBoundingClientRect().left - galleryLeft);
    if (distance < bestDistance) {
      bestDistance = distance;
      best = i;
    }
  }
  return best;
}

function initCardGallery(gallery) {
  if (gallery.dataset.galleryInit) return;
  gallery.dataset.galleryInit = 'true';

  var slides = gallery.querySelectorAll('.card-gallery__slide');
  if (slides.length < 2) return;

  // Cards inside a product slider/carousel keep only their first photo static
  // (see .collection-products-list--slider .card-gallery in CSS) — don't wire
  // up swipe/hover behavior there, it would fight the section's own scroll.
  var isInSlider = !!gallery.closest('.collection-products-list--slider');
  if (isInSlider) return;

  var figure = gallery.closest('.card-custom-image');
  var dotsWrap = figure ? figure.querySelector('[data-card-gallery-dots]') : null;

  // Lazy-load each slide's image only once it actually scrolls into view
  // within the gallery itself (native loading="lazy" doesn't account for
  // horizontal scroll-container clipping, so it was loading everything upfront).
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadSlideImage(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { root: gallery, threshold: 0.1 }
    );
    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  } else {
    slides.forEach(loadSlideImage);
  }

  gallery.addEventListener(
    'pointerdown',
    function () {
      preloadNeighbours(gallery, getActiveSlideIndex(gallery));
    },
    { once: true }
  );

  var scrollTimeout;
  gallery.addEventListener('scroll', function () {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function () {
      var index = getActiveSlideIndex(gallery);
      setActiveDot(dotsWrap, index);
      preloadNeighbours(gallery, index);
    }, 80);
  });

  var cardWrapper = gallery.closest('.card-wrapper');
  if (cardWrapper && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    cardWrapper.addEventListener('mouseenter', function () {
      scrollGalleryToIndex(gallery, 1);
    });
    cardWrapper.addEventListener('mouseleave', function () {
      scrollGalleryToIndex(gallery, 0);
    });
  }
}

function initAllCardGalleries() {
  document.querySelectorAll('[data-card-gallery]').forEach(initCardGallery);
}

// Filtri, ordinamento e paginazione sostituiscono la griglia via innerHTML:
// le card nuove arrivano senza gestori e con le foto successive ancora
// rimandate (solo data-src), quindi non si caricherebbero mai. Un observer
// sul contenitore le reinizializza a ogni sostituzione. Osserva solo childList,
// mentre l'inizializzazione tocca attributi: nessun ciclo infinito.
function watchGridReplacements() {
  var grid = document.getElementById('ProductGridContainer');
  if (!grid || grid.dataset.galleryWatch) return;
  grid.dataset.galleryWatch = 'true';

  var pending;
  new MutationObserver(function () {
    clearTimeout(pending);
    pending = setTimeout(initAllCardGalleries, 50);
  }).observe(grid, { childList: true, subtree: true });
}

function bootCardGalleries() {
  initAllCardGalleries();
  watchGridReplacements();
}

document.addEventListener('DOMContentLoaded', bootCardGalleries);
document.addEventListener('shopify:section:load', bootCardGalleries);

document.addEventListener('click', function (event) {
  var swatch = event.target.closest('.card-color-swatch');
  if (!swatch) return;

  event.preventDefault();

  var refs = getCardGallery(swatch);
  var targetIndex = 0;
  var matched = false;

  if (refs && refs.gallery) {
    var mediaId = swatch.dataset.variantMediaId;
    if (mediaId) {
      var slides = refs.gallery.querySelectorAll('.card-gallery__slide');
      slides.forEach(function (slide, i) {
        if (slide.dataset.mediaId === mediaId) {
          targetIndex = i;
          matched = true;
        }
      });
    }
  }

  if (matched) {
    scrollGalleryToIndex(refs.gallery, targetIndex, 'auto');
    setActiveDot(refs.dotsWrap, targetIndex);
  } else {
    var imageUrl = swatch.dataset.variantImage;
    if (imageUrl && refs && refs.figure) {
      var images = refs.figure.querySelectorAll('.card-gallery img');
      images.forEach(function (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.removeAttribute('data-src');
        img.src = imageUrl;
      });
    }
  }

  var group = swatch.closest('.card-color-swatches');
  group.querySelectorAll('.card-color-swatch').forEach(function (el) {
    el.classList.remove('active');
  });
  swatch.classList.add('active');
});

document.addEventListener('click', function (event) {
  if (event.target.closest('.card-quick-add')) {
    event.preventDefault();
  }
});
